export default __webpack_public_path__ + "static/media/ai.4298a029.webp";